import React, { createContext, useContext, useReducer, useEffect } from 'react';

// ─── Catalogue de partenaires fidélité — géré par l'admin, affiché en
// lecture seule côté client. Même pattern que FleetContext.jsx : pas de
// backend pour ce catalogue, persistance dans localStorage, partagée entre
// l'espace admin et l'espace client (montés séparément par App.jsx).
const STORAGE_KEY = 'om_loyalty_v1';

const PARTNERS_INIT = [
  { id: 'p1', name: 'Café Dakar', category: 'Restauration', perk: '-10% sur toute commande', zone: 'Plateau', active: true, validUntil: '2026-12-31' },
  { id: 'p2', name: 'AutoLavage Sénégal', category: 'Entretien auto', perk: 'Lavage offert dès 10 trajets/mois', zone: 'Almadies', active: true, validUntil: '2026-12-31' },
  { id: 'p3', name: 'Pharmacie de la Corniche', category: 'Santé', perk: '-5% sur les achats', zone: 'Almadies', active: true, validUntil: '' },
];

const initState = { partners: PARTNERS_INIT };

function loadInit() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return initState;
    return { ...initState, ...JSON.parse(raw) };
  } catch {
    return initState;
  }
}

function reducer(state, action) {
  switch (action.type) {
    case 'ADD_PARTNER':
      return { ...state, partners: [action.partner, ...state.partners] };
    case 'UPDATE_PARTNER':
      return { ...state, partners: state.partners.map((p) => (p.id === action.id ? { ...p, ...action.updates } : p)) };
    case 'DELETE_PARTNER':
      return { ...state, partners: state.partners.filter((p) => p.id !== action.id) };
    default:
      return state;
  }
}

const LoyaltyCtx = createContext(null);

export function LoyaltyProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, undefined, loadInit);

  useEffect(() => {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch { /* stockage indisponible — on continue sans persister */ }
  }, [state]);

  return <LoyaltyCtx.Provider value={{ ...state, dispatch }}>{children}</LoyaltyCtx.Provider>;
}

export const useLoyalty = () => {
  const ctx = useContext(LoyaltyCtx);
  if (!ctx) throw new Error('useLoyalty must be used within a LoyaltyProvider');
  return ctx;
};
